import Vue from "vue";
import RoSignUp from "./RoSignUp";
import RoSignUpBox from "./RoSignUpBox";

Vue.component("RoSignUp", RoSignUp);
Vue.component("RoSignUpBox", RoSignUpBox);

export default RoSignUp;



// WEBPACK FOOTER //
// ./scripts/ro-sign-up/index.js